import { makePrimaryContact, makeRequestContact } from "../api/api-methods";
import { CONTACT_CATEGORY } from "./requestContactDesignations";

/** Apply contact designation radios via ProviderService endpoints. */
export async function applyContactDesignations({
  provider_user_id,
  provider_id,
  rfiDesignation,
  assessmentDesignation,
  eligibleCategories = [],
}) {
  const tasks = [];

  if (eligibleCategories.includes(CONTACT_CATEGORY.RFI)) {
    if (rfiDesignation === "primary") {
      tasks.push(makePrimaryContact({ provider_id, provider_user_id, category: CONTACT_CATEGORY.RFI }));
    } else {
      tasks.push(
        makeRequestContact({
          provider_user_id,
          request_contact_status: rfiDesignation === "request",
          category: CONTACT_CATEGORY.RFI,
        }),
      );
    }
  }

  if (eligibleCategories.includes(CONTACT_CATEGORY.ASSESSMENT)) {
    if (assessmentDesignation === "primary") {
      tasks.push(
        makePrimaryContact({ provider_id, provider_user_id, category: CONTACT_CATEGORY.ASSESSMENT }),
      );
    } else {
      tasks.push(
        makeRequestContact({
          provider_user_id,
          request_contact_status: assessmentDesignation === "request",
          category: CONTACT_CATEGORY.ASSESSMENT,
        }),
      );
    }
  }

  await Promise.all(tasks);
}
